import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            allSalesReps: [],
        };
    },
    getters: {
        allSalesReps: (state) => state.allSalesReps,
    },
    actions: {
        async getAllSalesReps({ commit }) {
            //fetch list of all sales reps
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-sales-reps").then((data) => {
                    commit("setAllSalesReps", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                window.location.href = "/";
                console.log(error);
            }
        },
        async addSalesRep({ commit, dispatch }, request) {
            //add sales rep
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/store-sales-rep", request)
                    .then((resp) => {
                        window.emitter.emit("alertSuccess", {
                            message: "Sales Rep added successfully!",
                        });
                        dispatch("getAllSalesReps");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async updateSalesRep({ commit, dispatch }, request) {
            //update sales rep
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-sales-rep", request)
                    .then((resp) => {
                        window.emitter.emit("alertSuccess", {
                            message: "Sales Rep updated successfully!",
                        });
                        dispatch("getAllSalesReps");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async assignSalesRepToLocation({ commit }, request) {
            //assign sales rep to location
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/assign-sales-rep-to-location", request)
                    .then((resp) => {
                        window.emitter.emit("alertSuccess", {
                            message:
                                "Sales Rep assigned to a location successfully!",
                        });
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
    },
    mutations: {
        setAllSalesReps(state, allSalesReps) {
            state.allSalesReps = allSalesReps;
        },
    },
};
